import styled from 'styled-components'

import { Typography } from 'components/Typography/Typography'
import { useAppTheme } from 'contexts/ThemeProviderContext'
import { IconAsymptotic } from 'components/Icons/IconAsymptotic'

const BuiltBy = styled.div`
  display: flex;
  // align-items: center;
  margin: 40px auto;
  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    max-width: 1200px;
    width: 100%;
    margin: auto;
    margin-top: 40px;
  }
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 0 20px;
    justify-content: space-between;
  }
`

const KunaLabsContainer = styled.div`
  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    margin-right: 40px;
  }
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-bottom: 20px;
  }
`

const MovebitContainer = styled.div`
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-bottom: 20px;
  }
`

const AuditedByContainer = styled.div`
  display: flex;
  align-items: center;

  a {
    display: flex;
  }

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    flex-direction: column;
    gap: 10px;
  }
`

export const BuildBySection = () => {
  const { theme } = useAppTheme()

  return (
    <BuiltBy style={{ marginBottom: 40 }}>
      <KunaLabsContainer>
        <Typography variant="label2" color="secondary" fontWeight="light" style={{ marginBottom: 10 }}>
          Built by
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <a href="https://kunalabs.io/" target="_blank" rel="noreferrer">
            <img src={theme === 'dark' ? '/kuna-labs-dark.png' : '/kuna-labs-light.png'} alt="Kuna Labs" />
          </a>
        </div>
      </KunaLabsContainer>
      <MovebitContainer>
        <Typography variant="label2" color="secondary" fontWeight="light" style={{ marginBottom: 10 }}>
          Audited by
        </Typography>
        <AuditedByContainer>
          <a href="https://docs.kai.finance/resources/audits" target="_blank" rel="noreferrer">
            <img src={theme === 'dark' ? '/movebit-dark.png' : '/movebit.png'} alt="Movebit" />
          </a>
          <div style={{ width: 16 }} />
          <a href="https://docs.kai.finance/resources/audits" target="_blank" rel="noreferrer">
            <IconAsymptotic width={154} height={32} />
          </a>
          <div style={{ width: 16 }} />
          <a href="https://docs.kai.finance/resources/audits" target="_blank" rel="noreferrer">
            <img
              width={154}
              height={32}
              src={theme === 'dark' ? '/ottersec-white.png' : '/ottersec-black.png'}
              alt="Ottersec"
            />
          </a>
        </AuditedByContainer>
      </MovebitContainer>
    </BuiltBy>
  )
}
